import { useEffect } from "react";

interface UseAutoSelectInputTextOptions {
  isOpen: boolean;
  inputSelector: string;
  /**
   * Optional stable value to re-trigger selection when opening for a different
   * asset (but NOT on user typing). Prefer the asset's existing name here.
   */
  value?: string;
}

export function useAutoSelectInputText({
  isOpen,
  inputSelector,
  value,
}: UseAutoSelectInputTextOptions) {
  useEffect(() => {
    if (!isOpen) return;

    const timeoutHandle = setTimeout(() => {
      const inputElement = document.querySelector<
        HTMLInputElement | HTMLTextAreaElement
      >(inputSelector);
      inputElement?.select();
    }, 0);

    return () => clearTimeout(timeoutHandle);
  }, [inputSelector, isOpen, value]);
}
